export default __webpack_public_path__ + "static/media/error-img.5206e328.png";